// components/chat/EmptyState.js
import React from 'react';
import './EmptyState.css';

const EmptyState = ({ handleSuggestionClick }) => {
  // Instructions for using the system
  const instructions = [
    "Type #REQ-821 or #REQ-821,REQ-822 to generate tests for a specific Jira ticket(s)",
    "Type /prompt: <requirements> to start new test generation",
    "Upload test files for context before submitting requirements",
    "Ask for test case optimization or coverage improvements"
  ];

  return (
    <div className="empty-state">
      <div className="empty-state-logo">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="48">
          <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
          <path d="M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" fill="currentColor" />
          <path d="M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" fill="currentColor" />
          <path d="M20 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" fill="currentColor" />
        </svg>
      </div>
      <h2>Test Case Generation Assistant</h2>
      <p>Get started with one of these options:</p>
      <div className="suggestion-chips">
        {instructions.map((instruction, index) => {
          // Safely handle the instruction text
          const instructionText = typeof instruction === 'object' ? 
            JSON.stringify(instruction) : instruction;
            
          return (
            <button 
              key={index} 
              className="suggestion-chip"
              onClick={() => handleSuggestionClick(instructionText)}
            >
              {instructionText}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EmptyState;